import { CHAT_SEARCH_BUYER_URL, CHAT_SEARCH_LIST_BUYER_URL, CHAT_SEARCH_SELLER_URL, CHAT_TASK_LIST_BUYER_URL, CHAT_USER_LIST_BUYER_URL, READ_ALL_NOTIFICATION_URL, USER_CHAT_STATUS_URL } from "../../api";
import axiosInstance from "../../axiosInstance";


export const chatListBuyer = (search) => onResponse => {
    try {
        axiosInstance.get(CHAT_SEARCH_LIST_BUYER_URL + '?search=' + search)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const chatTaskListBuyer = (user, page, per_page) => onResponse => {
    try {
        axiosInstance.get(CHAT_TASK_LIST_BUYER_URL + '?user=' + user + '&page=' + page + '&per_page=' + per_page)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }
};

export const chatSearchBuyer = () => onResponse => {
    try {
        axiosInstance.get(CHAT_SEARCH_BUYER_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const chatUserListBuyer = () => onResponse => {
    try {
        axiosInstance.get(CHAT_USER_LIST_BUYER_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const chatSearchSeller = () => onResponse => {
    try {
        axiosInstance.get(CHAT_SEARCH_SELLER_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const userChatStatus = (status) => onResponse => {
    try {
        axiosInstance.post(USER_CHAT_STATUS_URL, { status })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const readAllNotification = (id, in_chat) => onResponse => {

    try {
        axiosInstance.post(READ_ALL_NOTIFICATION_URL, { assigned_task: id, in_chat: in_chat, notification_token: localStorage.getItem('onesignal_token') })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};